// src/utils/exportToExcel.js
import * as XLSX from "@lokalise/xlsx";
import { saveAs } from "file-saver";

export const exportToExcel = (MetaData, records, fileName = "data") => {
  // Step 1: Define meta rows
  const metaRows = MetaData;

  // Step 2: Convert records to sheet
  const dataRows = XLSX.utils.json_to_sheet(records, { skipHeader: false });

  // Step 3: Create new worksheet & insert meta rows manually
  const worksheet = {};
  const metaSheet = XLSX.utils.aoa_to_sheet(metaRows);

  // Merge meta and data sheets
  Object.assign(worksheet, metaSheet);

  const dataRange = XLSX.utils.decode_range(dataRows["!ref"]);
  for (let R = dataRange.s.r; R <= dataRange.e.r; ++R) {
    for (let C = dataRange.s.c; C <= dataRange.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({
        r: R + metaRows.length,
        c: C,
      });
      const sourceAddress = XLSX.utils.encode_cell({ r: R, c: C });
      worksheet[cellAddress] = dataRows[sourceAddress];
    }
  }

  worksheet["!ref"] = XLSX.utils.encode_range({
    s: { r: 0, c: 0 },
    e: { r: dataRange.e.r + metaRows.length, c: dataRange.e.c },
  });

  // Step 4: Create workbook and trigger download
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, `${fileName}.xlsx`);
};
